<template src="./LocaleSwitch.html">
</template>

<script>
export default {
  name: 'locale-changer',
  data () {
    return { langs: [ { 'text': 'English', 'value': 'en' }, { 'text': 'Français', 'value': 'fr' }] }
  },
  mounted() {
    if (localStorage.Lang != null)
      this.$i18n.locale = localStorage.Lang;
  },
  methods: {
    langChanged(lang) {
      localStorage.Lang = lang;
      window.location.reload();
    }
  }
}
</script>
